import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import Utils from "utils";
import openNotification from "utils/notification";
import cloneDeep from "lodash";
import DriverService from "services/DriverService";

export const getDriverSummary = createAsyncThunk(
  "driver/getDriverSummary",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DriverService.getDriverSummary(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllDriverApi = createAsyncThunk(
  "driver/getAllDriverApi",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DriverService.getAllDriver(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDriverById = createAsyncThunk(
  "driver/getDriverById",
  async (id, { rejectWithValue }) => {
    try {
      const response = await DriverService.getDriverById(id);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const createDriverApi = createAsyncThunk(
  "driver/createDriver",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverService.createDriver(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const updateDriverApi = createAsyncThunk(
  "driver/updateDriver",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverService.updateDriver(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const delDriverApi = createAsyncThunk(
  "driver/delDriverApi",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess, id } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverService.delDriver(id);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);
export const changeStatusDriver = createAsyncThunk(
  "driver/changeStatusDriver",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverService.changeStatusDriver(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const monitoringDriver = createAsyncThunk(
  "driver/monitoringDriver",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverService.monitoringMobileDriver(payload);
      if (onSuccess) onSuccess(response);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const monitoringDetailDriver = createAsyncThunk(
  "driver/monitoringDetailDriver",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DriverService.monitoringMobileDetailDriver(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);
export const monitoringDriverHistoryDriver = createAsyncThunk(
  "driver/monitoringDriverHistoryDriver",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DriverService.monitoringHistoryDriver(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getAllActiveDriverApi = createAsyncThunk(
  "driver/getAllActiveDriverApi",
  async (_, { rejectWithValue }) => {
    try {
      const response = await DriverService.getAllActiveDriver();
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const getDriversValid = createAsyncThunk(
  "driver/getDriversValid",
  async (data, { rejectWithValue }) => {
    try {
      const response = await DriverService.getDriversValid(data);
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

export const assignDriver = createAsyncThunk(
  "driver/assignDriver",
  async (data, { rejectWithValue }) => {
    try {
      const { onSuccess } = data;
      const payload = cloneDeep(data);
      delete payload.onSuccess;
      const response = await DriverService.assignDriver(payload);
      if (onSuccess) onSuccess(response);
      openNotification(
        "success",
        Utils.setLocale("admin.settings.popup.notification.success"),
        Utils.setLocale("admin.settings.popup.notification.title"),
      );
      return response.data;
    } catch (err) {
      return rejectWithValue(err.message || "Error");
    }
  },
);

const initialState = {
  loading: false,
  driverSummary: {},
  driverList: [],
  driverActiveList: [],
  driverDetail: {},
  driverSummaryMonitor: {
    totalCount: 0,
    // totalOnline: 0,
    totalOffline: 0,
    // totalLossGps: 0,
    totalEmpty: 0,
    totalWaitingArrive: 0,
    totalComingIn: 0,
    totalArrived: 0,
    totalStarted: 0,
  },
  driversMonitor: [],
  driversValid: [],
};
export const storeDriverSlice = createSlice({
  name: "driver",
  initialState,
  reducers: {
    showLoading: (state) => {
      state.loading = true;
    },
    setDriver: (state, action) => {
      state.driverList = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(monitoringDriver.pending, (state) => {
        state.loading = true;
      })
      .addCase(monitoringDriver.fulfilled, (state, action) => {
        state.loading = false;
        const {
          drivers,
          totalCount,
          // totalOnline,
          totalOffline,
          // totalLossGps,
          totalEmpty,
          totalWaitingArrive,
          totalComingIn,
          totalArrived,
          totalStarted,
        } = action.payload;
        state.driverSummaryMonitor = {
          totalCount,
          // totalOnline,
          totalOffline,
          // totalLossGps,
          totalEmpty,
          totalWaitingArrive,
          totalComingIn,
          totalArrived,
          totalStarted,
        };
        state.driversMonitor = drivers;
      })
      .addCase(monitoringDriver.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getDriverSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDriverSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.driverSummary = action.payload;
      })
      .addCase(getDriverSummary.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllDriverApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllDriverApi.fulfilled, (state, action) => {
        state.loading = false;
        state.driverList = action.payload;
      })
      .addCase(getAllDriverApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getDriverById.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDriverById.fulfilled, (state, action) => {
        state.loading = false;
        state.driverDetail = action.payload;
      })
      .addCase(getDriverById.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(createDriverApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(createDriverApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(createDriverApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDriverApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(updateDriverApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(updateDriverApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(delDriverApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(delDriverApi.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(delDriverApi.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusDriver.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeStatusDriver.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(changeStatusDriver.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(getAllActiveDriverApi.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllActiveDriverApi.fulfilled, (state, action) => {
        state.loading = false;
        state.driverActiveList = action.payload;
      })
      .addCase(getAllActiveDriverApi.rejected, (state) => {
        state.loading = false;
      })
      .addCase(getDriversValid.pending, (state) => {
        state.loading = true;
      })
      .addCase(getDriversValid.fulfilled, (state, action) => {
        state.loading = false;
        state.driversValid = action.payload;
      })
      .addCase(getDriversValid.rejected, (state, action) => {
        state.loading = false;
      })
      .addCase(assignDriver.pending, (state) => {
        state.loading = true;
      })
      .addCase(assignDriver.fulfilled, (state, action) => {
        state.loading = false;
      })
      .addCase(assignDriver.rejected, (state, action) => {
        state.loading = false;
      });
  },
});

export const { showLoading, setDriver } = storeDriverSlice.actions;

export default storeDriverSlice.reducer;
